import Api from "../../../util/Api";

export default function getInitState() {
    return {
        gridIsOpen: true,
        formIsOpen: false,
        additionalTableIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            checkbox_rows: false,
            global_search: {
                visibility: false,
            }
        },
        additionalDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            checkbox_rows: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új árlista',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "siteId",
                label: "Telephely",
                visibility: false,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: 'partnerId',
                label: 'Partner',
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: 'szamlazott',
                label: 'Számlázott',
                formSize: 4,
                formType: 'checkbox',
            },
            {
                name: "startDateFrom",
                label: "Kezelés dátumától",
                formSize: 4,
                formType: "date"
            },
            {
                name: "startDateTo",
                label: "Kezelés dátumáig",
                formSize: 4,
                formType: "date"
            }
        ],
        additionalHeaderFields: [
            {
                name: "id",
                label: "Árlista ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "treatmentTypeId",
                label: "Kezelés kód",
                visibility: true,
                formVisible: false
            },
            {
                name: "treatmentTypeName",
                label: "Név",
                visibility: true,
                formVisible: false
            },
            {
                name: "price",
                label: "Ár",
                visibility: true,
                formVisible: true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Árlista ID",
                visibility: false
            },
            {
                name: "name",
                label: "Árlista neve",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false,
                visibility: true
            }
        ],

        selectPartnerDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        selectPartnerRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectPartner'
            }
        ],
        selectPartnerHeaderFields: [
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "fullName",
                label: "Teljes név",
                filter: {
                    type: "simple",
                }
            },
            {
                name: "taxNumber",
                label: "Adószám"
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
